export const ScientificAmericanLogo = (props) => (
  <svg
    viewBox="0 0 546.54 172.45"
    fill="currentColor"
    role="img"
    aria-label="Scientific American"
    {...props}
  >
    <path
      className="cls-1"
      d="m98.55,81.93c14.82-.04,25.51-11.75,27.21-27.63l-2.96-.85c-3.39,11.01-9.63,16.62-18.63,16.62-16.3,0-21.38-19.9-21.38-37.16,0-20.75,8.15-28.37,18.84-28.37,7.62,0,15.77,7.62,19.27,22.12h2.75V1.27h-2.54c-.21,1.69-1.16,2.75-2.86,2.75-2.54,0-7.62-4.02-15.77-4.02-19.8,0-38.21,16.09-38.21,43.19,0,23.18,14.61,38.8,34.3,38.74Z"
    />
    <path
      className="cls-1"
      d="m247.28,78.33c-6.14,0-9.63-1.48-9.63-11.01V11.75l44.78,69.44h3.6V12.39c0-7.73,1.8-8.79,6.88-8.79V1.27h-21.38v2.33c5.82,0,8.89,1.27,8.89,11.01v31.33L252.04,1.27h-26.36v2.33c4.45.21,6.35,1.27,6.35,7.94v58.01c0,7.83-1.91,8.79-6.35,8.79v2.33h21.59v-2.33Z"
    />
    <path
      className="cls-1"
      d="m314.08,5.93h3.39v64.57c0,7.2-1.59,7.83-7.62,7.83v2.33h33.34v-2.33c-5.72,0-7.62-.64-7.62-7.83V5.93h3.39c9.74,0,14.29,2.65,14.61,17.04h2.75V1.27h-59.49v21.7h2.75c.32-14.4,4.87-17.04,14.5-17.04Z"
    />
    <path
      className="cls-1"
      d="m518.38,81.93c14.82-.04,24.66-11.75,26.36-27.63l-2.96-.74c-3.39,11.01-8.79,16.51-17.78,16.51-16.3,0-20.75-19.9-20.75-37.16,0-20.75,7.94-28.37,18.63-28.37,7.62,0,15.77,7.62,19.27,22.12h2.75V1.27h-2.54c-.21,1.69-1.16,2.75-2.86,2.75-2.54,0-7.62-4.02-15.77-4.02-19.8,0-38,16.09-38,43.19,0,23.18,13.97,38.8,33.66,38.74Z"
    />
    <path
      className="cls-1"
      d="m10.59,77.59c3.07,0,6.99,4.23,19.37,4.23,18.21,0,29-11.43,29-23.82,0-10.48-4.98-17.25-15.24-22.97l-12.49-6.99c-5.4-3.07-9.95-7.09-9.95-13.23,0-6.56,4.98-10.27,12.91-10.27s15.14,5.61,17.36,17.68h2.65V1.27h-2.43c-.21,1.91-1.16,2.75-2.33,2.75-2.75,0-6.03-3.92-16.83-3.92C18.42.11,6.77,8.68,6.77,21.81c0,9.74,4.34,15.77,13.02,20.75l12.81,7.3c7.3,4.23,10.27,8.26,10.27,14.29,0,7.52-4.23,13.02-14.18,13.02-12.39,0-18.1-6.77-20.43-21.59h-2.86v25.09h2.65c.21-2.22,1.27-3.07,2.54-3.07Z"
    />
    <path
      className="cls-1"
      d="m426.6,78.33c-5.4,0-7.62-.64-7.62-7.94v-28.05h6.99c7.83,0,9.63,3.39,9.95,10.59h2.65v-25.62h-2.65c-.32,7.52-2.12,10.37-9.95,10.37h-6.99V5.93h9c13.87,0,16.83,4.23,17.36,15.56h2.75V1.27h-53.35v2.33c4.45,0,6.35.53,6.35,7.94v58.86c0,7.3-1.91,7.94-6.35,7.94v2.33h31.86v-2.33Z"
    />
    <path
      className="cls-1"
      d="m390.82,78.33c-4.45,0-6.35-.64-6.35-7.94V11.54c0-7.52,1.91-7.94,6.35-7.94V1.27h-30.8v2.33c4.45,0,6.46.42,6.46,7.94v58.86c0,7.3-2.01,7.94-6.46,7.94v2.33h30.8v-2.33Z"
    />
    <path
      className="cls-1"
      d="m483.02,78.33c-4.45,0-6.35-.64-6.35-7.94V11.54c0-7.52,1.91-7.94,6.35-7.94V1.27h-30.8v2.33c4.45,0,6.46.42,6.46,7.94v58.86c0,7.3-2.01,7.94-6.46,7.94v2.33h30.8v-2.33Z"
    />
    <path
      className="cls-1"
      d="m199.96,76h-10.9v-34.4h7.73c7.62,0,9.53,3.39,9.84,10.48h2.65v-25.3h-2.65c-.32,7.41-2.22,10.27-9.84,10.27h-7.73V5.93h10.16c13.87,0,16.94,4.23,17.36,14.93h2.75V1.27h-54.52v2.33c4.45,0,6.35.42,6.35,7.94v58.86c0,7.3-1.91,7.94-6.35,7.94v2.33h56.1v-22.02h-2.75c-.95,13.76-4.23,17.36-18.21,17.36Z"
    />
    <path
      className="cls-1"
      d="m130.2,3.6c4.45,0,6.46.42,6.46,7.94v58.86c0,7.3-2.01,7.94-6.46,7.94v2.33h30.8v-2.33c-4.45,0-6.35-.64-6.35-7.94V11.54c0-7.52,1.91-7.94,6.35-7.94V1.27h-30.8v2.33Z"
    />
    <path
      className="cls-1"
      d="m117.92,138.89l-15.98-47.11h-26.99v2.33c4.45.21,6.35,1.27,6.35,7.94v56c0,8.05-2.22,10.8-7.09,10.8-3.39,0-6.03-2.54-8.68-9.21l-26.25-68.81h-3.6l-26.25,69.02c-2.65,7.09-5.93,9-9.42,9v2.33h24.98v-2.33c-7.73-.32-11.54-3.6-7.73-13.97l2.65-7.2h23.08l4.45,11.96c3.07,7.62.85,9.21-4.98,9.21v2.33h52.82v-2.33c-5.5,0-8.36-1.59-8.36-10.69l.64-56.1,22.76,68.38h2.86l23.5-68.07v58.54c0,7.3-2.33,7.94-6.77,7.94v2.33h31.12v-2.33c-4.45,0-6.35-.64-6.35-7.94v-58.86c0-7.41,1.91-7.94,6.35-7.94v-2.33h-26.46l-16.62,47.11Zm-96.33,4.13l9.74-26.46,9.84,26.46h-19.58Z"
    />
    <path
      className="cls-1"
      d="m298.91,94.12c4.45,0,6.46.42,6.46,7.94v58.86c0,7.3-1.2,7.94-5.01,7.94-3.49,0-5.23-.95-10.2-9.21l-17.15-28.58c9.95-3.92,14.82-11.01,14.82-19.05,0-16.09-14.18-20.22-32.18-20.22h-29.96v2.33c4.45,0,6.35.42,6.35,7.94v58.86c0,7.3-1.91,7.94-6.35,7.94v2.33h31.86v-2.33c-5.29,0-7.52-.64-7.52-7.94v-26.57h5.61l21.49,36.84h52.58v-2.33c-4.45,0-6.35-.64-6.35-7.94v-58.86c0-7.52,1.91-7.94,6.35-7.94v-2.33h-30.8v2.33Zm-45.07,35.57h-3.81v-33.34h3.81c10.48,0,15.77,6.35,15.77,18.52,0,9.21-2.75,14.82-15.77,14.82Z"
    />
    <path
      className="cls-1"
      d="m199.96,166.52h-10.9v-34.4h7.73c7.62,0,9.53,3.39,9.84,10.48h2.65v-25.3h-2.65c-.32,7.41-2.22,10.27-9.84,10.27h-7.73v-31.12h10.16c13.87,0,16.94,4.23,17.36,14.93h2.75v-19.58h-54.52v2.33c4.45,0,6.35.42,6.35,7.94v58.86c0,7.3-1.91,7.94-6.35,7.94v2.33h56.1v-22.02h-2.75c-.95,13.76-4.23,17.36-18.21,17.36Z"
    />
    <path
      className="cls-1"
      d="m395.53,143.98c-3.39,11.01-9.88,16.62-20.01,16.62-16.58,0-22.55-19.9-22.55-37.16,0-20.04,7.8-28.37,19.12-28.37,8.68,0,18.03,7.62,21.52,22.12h2.75v-25.41h-2.54c-.21,1.69-1.16,2.75-2.86,2.75-2.54,0-8.82-4.02-18.03-4.02-20.43,0-38.5,16.8-38.5,43.19,0,23.18,15.49,38.8,35.46,38.74,16.16-.04,26.61-12.03,28.58-27.63l-2.96-.85Z"
    />
    <path
      className="cls-1"
      d="m524.1,91.79v2.33c5.82,0,8.89,1.27,8.89,11.01v32.29l-33.34-45.62h-29.64v2.33c4.45.21,9.21,2.75,9.21,9.42v54.41c0,8.68-3.25,10.9-7.45,10.9-3,0-6.17-2.43-8.93-9.21l-27.42-68.81h-4.02l-27.13,69.02c-2.68,6.77-7.09,9-10.9,9v2.33h26.46v-2.33c-7.73-.32-11.79-3.7-7.73-13.97l2.77-7.2h25.14l4.73,11.96c3.07,7.62.85,9.21-4.98,9.21v2.33h54.69v-2.33c-6.14,0-9.63-1.48-9.63-11.01v-56.35l50.18,70.22h3.6v-66.69c0-7.73,2.86-10.9,7.94-10.9v-2.33h-22.44Zm-107.44,51.23l10.61-27.59,10.9,27.59h-21.51Z"
    />
  </svg>
);

export default ScientificAmericanLogo;
